// available envs: prod; dev; and dev with TEST=true;
const env = {
  prod: false,
  dev: false,
  test: false,
  unsafeOverrideEnv: '',
}

// @ts-ignore
if (typeof process !== 'undefined' && process.env.NODE_ENV) {
  // @ts-ignore
  env.test = process.env.NODE_ENV === 'test'
  // @ts-ignore
  env.prod = process.env.NODE_ENV === 'production'
  // @ts-ignore
  env.dev = !env.prod
  // @ts-ignore
} else if (typeof import.meta !== 'undefined' && import.meta.env) {
  // @ts-ignore
  env.test = import.meta.env.MODE === 'test'
  // @ts-ignore
  env.prod = !!import.meta.env.PROD
  // @ts-ignore
  env.dev = !env.prod
}

export const isDev = env.dev
export const isProd = env.prod
export const isTest = env.test

export const getUnsafeOverrideEnv = () => env.unsafeOverrideEnv
export const setUnsafeOverrideEnv = (newEnv: string) => {
  env.unsafeOverrideEnv = newEnv
}
